import { useState } from "react";
import Enums from "../../utilities/enum";
import { SearchFiltersModal } from "../shared/searchFiltersModal";

export const ContraventionsFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialType,
	initialDvlaCode,
	initialStatus,
	initialAppliedFilters
}) => {
	const [type, setType] = useState(initialType)
	const [dvlaCode, setDvlaCode] = useState(initialDvlaCode)
	const [status, setStatus] = useState(initialStatus)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setType(null)
		setDvlaCode(null)
		setStatus(null)
		setAppliedFilters(null)
	}

	const contraventionTypeOptions = Object.entries(Enums.ContraventionTypes).slice(0, 2)

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ type, dvlaCode, status, appliedFilters }) }
			showModal={ showModal }
			key="contraventions-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Type</label>
					<select
						value={ type === null ? "" : type }
						onChange={ e => {
							const value = e.target.value === "" ? null : Number(e.target.value)
							setType(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Type"]
								} else {
									updatedFilters["Type"] = Enums.ContraventionTypes[value]
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						{
							contraventionTypeOptions.map(([key, value]) => <option value={ key }>{ value }</option>)
						}
					</select>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">DVLA Code</label>
					<select
						value={ dvlaCode === null ? "" : dvlaCode }
						onChange={ e => {
							const value = e.target.value === "" ? null : e.target.value
							setDvlaCode(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["DVLA Code"]
								} else {
									updatedFilters["DVLA Code"] = `${ value } - ${ Enums.DvlaCode[value] }`
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						{
							Object.entries(Enums.DvlaCode).map(([key, value]) => <option value={ key }>{ key } - { value }</option>)
						}
					</select>
				</div>

				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Status</label>
					<select
						value={ status === true ? "true" : status === false ? "false" : "" }
						onChange={ e => {
							const value = e.target.value === "true" ? true : e.target.value === "false" ? false : null
							setStatus(value)
							setAppliedFilters(prevState => {
								const updatedFilters = { ...prevState }
								if (value === null) {
									delete updatedFilters["Status"]
								} else {
									updatedFilters["Status"] = value ? "Active" : "Deactivated"
								}
								return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
							})
						} }
						className="border rounded px-2 py-1 w-100"
					>
						<option value="">All</option>
						<option value="true">Active</option>
						<option value="false">Deactivated</option>
					</select>
				</div>
			</div>
		</SearchFiltersModal>
	)
}
